import { Switch } from "react-router-dom";

import { SimpleRoute } from "app/AppRoute";
import { GuardedRoute } from "app/guardedRoutes/GuardedRoute";
import { PUBLIC_ROUTES, UNAUTHED_ROUTES } from "shared/Routes";

import { AuthedRoutes } from "./AuthedRoutes/AuthedRoutes";
import { PublicRoutes } from "./PublicRoutes/PublicRoutes";
import { UnauthedRoutes } from "./UnauthedRoutes/UnauthedRoutes";

export const WebRoutes = () => {
    return (
        <Switch>
            <SimpleRoute path={Object.values(PUBLIC_ROUTES)} exact>
                <PublicRoutes />
            </SimpleRoute>

            <GuardedRoute
                path={Object.values(UNAUTHED_ROUTES)}
                requires={{ authenticationStatus: "LoggedOut" }}
                exact
            >
                <UnauthedRoutes />
            </GuardedRoute>

            <GuardedRoute
                path="*"
                requires={{
                    authenticationStatus: "LoggedIn",
                    onboarded: false,
                }}
            >
                <AuthedRoutes />
            </GuardedRoute>
        </Switch>
    );
};
